import { makeRequest } from 'utils/requestLogger';

export default (submissionID) =>
  makeRequest('get', `/api/submissions/${submissionID}/comments`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/loadSubmissionComments.js